import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { CampaignsService, JobOffersService } from '../../services';
import { ToasterService } from 'angular2-toaster';
import { Router } from '@angular/router';

@Component({
  selector: 'app-delete-node',
  templateUrl: './app-delete-node.component.html',
  providers: [CampaignsService]
})

export class AppDeleteNodeComponent implements OnInit {
  modalRef: BsModalRef;
  @Input() type: string;
  @Input() id: number;
  @Input() status: string;
  @Input() redirect = true;
  @Input() tamplateButton = 'button';

  constructor(
    private modalService: BsModalService,
    private joService: JobOffersService,
    private campaignsServeice: CampaignsService,
    private toasterService: ToasterService,
    private router: Router
  ) {}

  ngOnInit() {}

  private openModal(_template: TemplateRef<any>, event: Event) {
    event.preventDefault();
    this.modalRef = this.modalService.show(_template);
  }

  public deleteNode() {
    if (this.type && this.id) {
      switch (this.type) {
        case 'joboffers':
          this.joService.deleteJobOffer(this.id).subscribe(success => {
            if (this.redirect === true) {
              this.modalRef.hide();
              this.toasterService.pop('success', 'Success', 'Job deleted!');
              this.router.navigate(['/recruiting']);
            }
          });
          break;
        case 'polls':
          this.campaignsServeice.deleteCampaign(this.id, this.status).subscribe(
            success => {
              if (this.redirect === true) {
                sessionStorage.removeItem('polls');
                this.modalRef.hide();
                this.toasterService.pop('success', 'Success', 'Poll deleted!');
                this.router.navigate(['/' + this.type]);
              }
            },
            error => {
              console.error(error);
            }
          );
          break;
        case 'articles':
          this.campaignsServeice.deleteCampaign(this.id, this.status).subscribe(
            success => {
              if (this.redirect === true) {
                sessionStorage.removeItem('articles');
                this.modalRef.hide();
                this.toasterService.pop('success', 'Success', 'Article deleted!');
                this.router.navigate(['/' + this.type]);
              }
            },
            error => {
              console.error(error);
            }
          );
          break;
      }
    }
  }

}
